import React, { useState, useEffect } from "react"

import Menu from "@mui/material/Menu";
import Stack from "@mui/material/Stack";
import { useDispatch } from "react-redux";
import Divider from "@mui/material/Divider";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { MuiAvatar } from "../MuiAvatar";
import { WEB_URL } from "../../api/URLs";
import MenuOptionItem from "./MenuOptionItem";
import { userActions } from "../../store/actions";
import { GTM_EVENTS, S3_BUCKET } from "../../constants";
import { MixPanelTrackedLink } from "../MixPaneTrackedLink";
import { UserService } from "../../services/storage.service";
import { useNonInitialEffect } from "../../hooks/UseNonInitialEffect";
import { PaperProps, StyledHeader } from "../StyledComponents/HeaderStyles";
import { LogoutIcon, ProfileIcon, SearchIcon, TCFLogo, TCFWhiteLogo } from "../Icons";

export function HeaderDesktop() {

    const dispatch = useDispatch();
    const [userData, setUserData] = useState({});
    const [logoUrl, setLogoUrl] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const openProfileMenu = Boolean(anchorEl);

    const logOut = () => {
        dispatch(userActions.logout())
    }

    useEffect(() => {
        if (window.location.pathname == '/' || window.location.pathname.split('/')[1] == "campaign")
            setLogoUrl(TCFWhiteLogo);

        else setLogoUrl(TCFLogo);

        if (UserService.isLoggedIn())
            setUserData({ ...UserService.getUser() });
    }, [])

    useNonInitialEffect(() => { setUserData({ ...UserService.getUser() }); }, [UserService.getToken()])

    return <StyledHeader>
        <Stack className="HeaderMainStack">
            <Container className="HeaderContainer">
                <Stack flexDirection={'row'} justifyContent={'space-between'}>

                    <MixPanelTrackedLink type="link" label="none" context="Logo icon in header" href="/" underline="none" color="inherit">
                        <img src={logoUrl} className="tcfLogo" />
                    </MixPanelTrackedLink>

                    <Stack className="HeaderRightStack">
                        <MixPanelTrackedLink type="link" label="start a fundraiser" context="header link" gtmEvent={GTM_EVENTS.START_FUNDRAISER_CLICKED} href={WEB_URL.CREATE_FUNDRAISER} underline="none" color="inherit">
                            <Typography >
                                START A FUNDRAISER
                            </Typography>
                        </MixPanelTrackedLink>

                        <MixPanelTrackedLink type="link" label="support a fundraiser" context="header link" gtmEvent={GTM_EVENTS.SUPPORT_FUNDRAISER_CLICKED} href={WEB_URL.FUNDRAISER_LISTING} underline="none" color="inherit">
                            <Typography >
                                SUPPORT A FUNDRAISER
                            </Typography>
                        </MixPanelTrackedLink>

                        <MixPanelTrackedLink type="link" label="about us" context="header link" href={WEB_URL.ABOUT_US} underline="none" color="inherit">
                            <Typography >
                                ABOUT US
                            </Typography>
                        </MixPanelTrackedLink>

                        <MixPanelTrackedLink type="iconButton" label="none" context="Search icon on header" href={WEB_URL.FUNDRAISER_LISTING} color="inherit">
                            <SearchIcon width={17} />
                        </MixPanelTrackedLink>

                        <Divider orientation="vertical" flexItem />

                        <Stack className="HeaderProfileStack">
                            {UserService.isLoggedIn() && userData ?
                                <>
                                    <MuiAvatar src={S3_BUCKET + userData.avatar} fullName={userData.first_name + " " + userData.last_name} />
                                    <Typography >Hi {userData.first_name?.split(" ")[0]}</Typography>
                                    <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
                                        <ArrowDropDownIcon />
                                    </IconButton>
                                    <Menu
                                        open={openProfileMenu}
                                        anchorEl={anchorEl}
                                        onClose={() => setAnchorEl(null)}
                                        PaperProps={PaperProps}
                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                    >
                                        <MenuOptionItem
                                            showDivider={false}
                                            details={{
                                                label: "PROFILE",
                                                url: "/profile?tab=5",
                                                icon: <ProfileIcon width={15} />
                                            }} />

                                        <MenuOptionItem
                                            showDivider={false}
                                            details={{
                                                label: "LOGOUT",
                                                onClick: logOut,
                                                icon: <LogoutIcon width={15} />
                                            }} />
                                    </Menu>
                                </>
                                :
                                <MixPanelTrackedLink linkButtonProps={{sx: {marginRight: '-12px'}}} type="link" label="login" context="header link" href={WEB_URL.LOGIN} underline="none" color="inherit">
                                    <Typography>
                                        LOGIN
                                    </Typography>
                                </MixPanelTrackedLink>
                            }
                        </Stack>
                    </Stack>
                </Stack>
            </Container>
        </Stack>
    </StyledHeader>
}